import React from "react";
import { useNavigate } from "react-router-dom";
export const Info =()=>{
	const navigate = useNavigate();

  const onclickNavigate=()=>{
    navigate('/')
  }
  return (
    <div>
      <title>Page Title</title>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <style dangerouslySetInnerHTML={{__html: "\n* {\n  box-sizing: border-box;\n}\n\n/* Style the body */\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0;\n}\n\n/* Header/logo Title */\n.header {\n  padding: 127px;\n  text-align: center;\n  background: url('https://slot-game.devsparxit.com/static/media/bg.3d24e409.jpg');\n  color: white;\n}\n\n/* Increase the font size of the heading */\n.header h1 {\n  font-size: 55px;\n}\n\n/* Sticky navbar - toggles between relative and fixed, depending on the scroll position. It is positioned relative until a given offset position is met in the viewport - then it \"sticks\" in place (like position:fixed). The sticky value is not supported in IE or Edge 15 and earlier versions. However, for these versions the navbar will inherit default position */\n.navbar {\n  overflow: hidden;\n  background-color: #333;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n}\n\n/* Style the navigation bar links */\n.navbar a {\n  float: left;\n  display: block;\n  color: white;\n  text-align: center;\n  padding: 14px 20px;\n  text-decoration: none;\n}\n\n\n/* Right-aligned link */\n.navbar a.right {\n  float: none;\n}\n\n/* Change color on hover */\n.navbar a:hover {\n  background-color: #ddd;\n  color: black;\n}\n\n/* Active/current link */\n.navbar a.active {\n  background-color: #666;\n  color: white;\n}\n\n/* Column container */\n.row {  \n  display: -ms-flexbox; /* IE10 */\n  display: flex;\n  -ms-flex-wrap: wrap; /* IE10 */\n  flex-wrap: wrap;\n}\n\n/* Create two unequal columns that sits next to each other */\n/* Sidebar/left column */\n.side {\n  -ms-flex: 50%; /* IE10 */\n  flex: 50%;\n  background-color: rgb(236, 230, 135);\n  padding: 20px;\n}\n\n/* Main column */\n.main {   \n  -ms-flex: 50%; /* IE10 */\n  flex: 50%;\n  background-color: rgb(236, 230, 135);\n  padding: 20px;\n  /* text-align: left; */\n\n}\n\n/* Fake image, just for this example */\n.fakeimg {\n  background-color: rgb(236, 230, 135);\n  width: 100%;\n  padding: 30px;\n}\n\n/* Footer */\n.footer {\n  padding: 300px;\n  text-align: center;\n  background: url('https://slot-game.devsparxit.com/static/media/bg.3d24e409.jpg');\n}\n\n/*header text style*/\n.headerText {\n  padding: 20px;\n  text-align: center;\n  color: #401404;\n}\ntable {\n  font-family: arial, sans-serif;\n  border-collapse: collapse;\n  width: 100%;\n  \n}\n\ntd, th {\n  border: 1px solid #ce5656;\n  text-align: center;\n  padding: 8px;\n}\n\ntr:nth-child(even) {\n  background-color: #dddddd;\n}\n\n/* Responsive layout - when the screen is less than 700px wide, make the two columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 700px) {\n  .row {   \n    flex-direction: column;\n  }\n}\n\n/* Responsive layout - when the screen is less than 400px wide, make the navigation links stack on top of each other instead of next to each other */\n@media screen and (max-width: 400px) {\n  .navbar a {\n    float: none;\n    width: 100%;\n  }\n}\n" }} />
      
      <div className="header">
      <div className='back-btn-wrap'>
							<button className='back-btn' onClick={onclickNavigate}></button>
						
						</div>
        <h1 className="headerText">Slot Machine</h1>
      </div>
      <div className="row">
        <div className="side">
          <h2>About game Rules</h2>
          <div className="fakeimg" style={{height: '300px', padding: 'auto', overflowX: 'auto'}}>
            <table>
              <tbody><tr>
                  <th>slot1</th>
                  <th>slot2</th>
                  <th>slot3</th>
                  <th>winning Type</th>
                </tr>
                <tr>
                  <td>🏆</td>
                  <td>🏆</td>
                  <td>🏆</td>
                  <td>80% JACKPOT</td>
                </tr>
                <tr>
                  <td>🏆</td>
                  <td>🏆</td>
                  <td>0</td>
                  <td>20% JACKPOT</td>
                </tr>
                <tr>
                  <td>🏆</td>
                  <td>0</td>
                  <td>🏆</td>
                  <td>20% JACKPOT</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🏆</td>
                  <td>🏆</td>
                  <td>20% JACKPOT</td>
                </tr>
                <tr>
                  <td>💲</td>
                  <td>💲</td>
                  <td>💲</td>
                  <td>10% JACKPOT</td>
                </tr>
                <tr>
                  <td>💲</td>
                  <td>💲</td>
                  <td>0</td>
                  <td>5% JACKPOT</td>
                </tr>
                <tr>
                  <td>💲</td>
                  <td>0</td>
                  <td>💲</td>
                  <td>5% JACKPOT</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>💲</td>
                  <td>💲</td>
                  <td>5% JACKPOT</td>
                </tr>
                <tr>
                  <td>🔥</td>
                  <td>🔥</td>
                  <td>🔥</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🔥</td>
                  <td>🔥</td>
                  <td>0</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🔥</td>
                  <td>0</td>
                  <td>🔥</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🔥</td>
                  <td>🔥</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🧨</td>
                  <td>🧨</td>
                  <td>🧨</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🧨</td>
                  <td>🧨</td>
                  <td>0</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🧨</td>
                  <td>0</td>
                  <td>🧨</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🧨</td>
                  <td>🧨</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>🎯</td>
                  <td>🎯</td>
                  <td>🎯</td>
                  <td>5 spins</td>
                </tr>
                <tr>
                  <td>🎯</td>
                  <td>🎯</td>
                  <td>0</td>
                  <td>2 spins</td>
                </tr>
                <tr>
                  <td>🎯</td>
                  <td>0</td>
                  <td>🎯</td>
                  <td>2 spins</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🎯</td>
                  <td>🎯</td>
                  <td>2 spins</td>
                </tr>
                <tr>
                  <td>🎰</td>
                  <td>🎰</td>
                  <td>🎰</td>
                  <td>10 spins</td>
                </tr>
                <tr>
                  <td>🎰</td>
                  <td>🎰</td>
                  <td>0</td>
                  <td>4 spins</td>
                </tr>
                <tr>
                  <td>🎰</td>
                  <td>0</td>
                  <td>🎰</td>
                  <td>4 spins</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🎰</td>
                  <td>🎰</td>
                  <td>4 spins</td>
                </tr>
                <tr>
                  <td>🪙</td>
                  <td>🪙</td>
                  <td>🪙</td>
                  <td>win 5000 Tokens</td>
                </tr>
                <tr>
                  <td>🪙</td>
                  <td>🪙</td>
                  <td>0</td>
                  <td>win 2000 Tokens</td>
                </tr>
                <tr>
                  <td>🪙</td>
                  <td>0</td>
                  <td>🪙</td>
                  <td>win 2000 Tokens</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🪙</td>
                  <td>🪙</td>
                  <td>win 2000 Tokens</td>
                </tr>
                <tr>
                  <td>🤑</td>
                  <td>🤑</td>
                  <td>🤑</td>
                  <td>win 10000 Tokens</td>
                </tr>
                <tr>
                  <td>🤑</td>
                  <td>🤑</td>
                  <td>0</td>
                  <td>win 4000 Tokens</td>
                </tr>
                <tr>
                  <td>🤑</td>
                  <td>0</td>
                  <td>🤑</td>
                  <td>win 4000 Tokens</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>🤑</td>
                  <td>🤑</td>
                  <td>win 4000 Tokens</td>
                </tr>
                <tr>
                  <td>💩</td>
                  <td>💩</td>
                  <td>💩</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>💩</td>
                  <td>💩</td>
                  <td>0</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>💩</td>
                  <td>0</td>
                  <td>💩</td>
                  <td>Nothing</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td>💩</td>
                  <td>💩</td>
                  <td>Nothing</td>
                </tr>
              </tbody></table>
          </div>
          <p>*Note :- zero(0) should be anything in the above table</p>
          <div className="fakeimg" style={{height: '60px'}} /><br />
          <div className="fakeimg" style={{height: '60px'}} /><br />
          <div className="fakeimg" style={{height: '60px'}} />
        </div>
        <div className="main">
          <h2>INTRODUCTION</h2>
          <p>This a slot machine directly interact with smart contract </p>
          <br />
          <h2>How to play </h2>
          <p>Some text..</p>
          <h2>Rules to win </h2>
          <p>Some text..</p>
        </div>
      </div>
      <div className="footer">
        <h2 />
      </div>
    </div>
  );
}
    
  

export default Info